module.exports = __webpack_public_path__ + "static/mr-online-program-music-world-wide-6-cebfb1b18afe77619f77abbf8fb397c3.jpg";